<div class="container on-demand-container" *ngIf="category">
  <!-- <h2 class="category-title">{{category.i18nName[translate.currentLang.toUpperCase()]}}</h2> -->
  <swiper-container [slidesPerView]="1.5" *ngIf="category.videos && category.videos.length > 0">
    <swiper-slide *ngFor="let video of category.videos; let i = index" class="slide">
      <div class="video" (click)="openVideo(video)">
        <div class="img-container">
          <div class="locked" *ngIf="video.videoBlocked">
            <img src="../../../../assets/img/Lucchetto.png" alt="" class="lock-icon">
          </div>
          <img *ngIf="video.i18nvideoId && video.i18nvideoId[translate.currentLang.toUpperCase()]"
            [src]="'https://play.vidyard.com/'+video.i18nvideoId[translate.currentLang.toUpperCase()]+'.jpg'"
            [attr.data-uuid]="video.i18nvideoId && video.i18nvideoId[translate.currentLang.toUpperCase()] ? video.i18nvideoId[translate.currentLang.toUpperCase()]: null"
            data-v="4" data-type="inline" />
        </div>
        <!-- <p>{{video.i18nName[translate.currentLang.toUpperCase()] ? video.i18nName[translate.currentLang.toUpperCase()] :
          null}}</p> -->
      </div>
    </swiper-slide>
  </swiper-container>
  <span *ngFor="let item of category.subCategories">
    <h2>{{item.i18nName[translate.currentLang.toUpperCase()]}}</h2>
    <swiper-container [slidesPerView]="1.5" *ngIf="item.videos && item.videos.length > 0">
      <swiper-slide *ngFor="let video of item.videos; let i = index" class="slide">
        <div class="video" (click)="openVideo(video)">
          <div class="img-container">
            <div class="locked" *ngIf="video.videoBlocked">
              <img src="../../../../assets/img/Lucchetto.png" alt="" class="lock-icon">
            </div>
            <img *ngIf="video.i18nvideoId && video.i18nvideoId[translate.currentLang.toUpperCase()]"
              [src]="'https://play.vidyard.com/'+video.i18nvideoId[translate.currentLang.toUpperCase()]+'.jpg'"
              [attr.data-uuid]="video.i18nvideoId && video.i18nvideoId[translate.currentLang.toUpperCase()] ? video.i18nvideoId[translate.currentLang.toUpperCase()]: null"
              data-v="4" data-type="inline" />
          </div>
          <!-- <p>{{video.i18nName[translate.currentLang.toUpperCase()] ? video.i18nName[translate.currentLang.toUpperCase()]
            : null}}</p> -->
        </div>
      </swiper-slide>
    </swiper-container>
  </span>
</div>
